"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeIsSupported = exports.getAvailableLocales = exports.getDefaultLocale = exports.getRegion = exports.getBrand = exports.brandExists = exports.getDefaultLocaleByRegion = exports.getAvailableLocalesByRegion = exports.getAvailableBrands = exports.getAvailableRegions = void 0;
var brands_1 = require("../configs/brands");
var localesAndRegions_1 = require("../configs/localesAndRegions");
/**
 * Get all available regions.
 */
var getAvailableRegions = function () { return Object.values(localesAndRegions_1.RegulatoryRegion); };
exports.getAvailableRegions = getAvailableRegions;
/**
 * Get all available brands.
 */
var getAvailableBrands = function () { return Object.values(brands_1.BrandName); };
exports.getAvailableBrands = getAvailableBrands;
/**
 * Get all available locales for the given region.
 * @param region
 */
var getAvailableLocalesByRegion = function (region) {
    return localesAndRegions_1.availableLocalesByRegion[region];
};
exports.getAvailableLocalesByRegion = getAvailableLocalesByRegion;
/**
 * Get the default locale for the given region.
 * @param region
 */
var getDefaultLocaleByRegion = function (region) {
    return localesAndRegions_1.defaultLocaleByRegion[region];
};
exports.getDefaultLocaleByRegion = getDefaultLocaleByRegion;
/**
 * Check if the given brand exists
 * @param brandName
 */
var brandExists = function (brandName) {
    return (0, exports.getAvailableBrands)().includes(brandName);
};
exports.brandExists = brandExists;
/**
 * Get the brand for the given instance.
 * @param instance
 */
var getBrand = function (instance) {
    return instance.brand;
};
exports.getBrand = getBrand;
/**
 * Get the region for the given instance.
 * @param instance
 */
var getRegion = function (instance) { return instance.region; };
exports.getRegion = getRegion;
/**
 * Get the default locale for the given instance.
 * @param instance
 */
var getDefaultLocale = function (instance) { var _a; return (_a = instance.defaultLocale) !== null && _a !== void 0 ? _a : (0, exports.getDefaultLocaleByRegion)(instance.region); };
exports.getDefaultLocale = getDefaultLocale;
/**
 * Get the available locales for the given instance.
 * @param instance
 */
var getAvailableLocales = function (instance) { var _a; return (_a = instance.availableLocales) !== null && _a !== void 0 ? _a : (0, exports.getAvailableLocalesByRegion)(instance.region); };
exports.getAvailableLocales = getAvailableLocales;
/**
 * Check if the given locale is supported by the given instance.
 * @param locale
 * @param instance
 */
var localeIsSupported = function (locale, instance) {
    var _a;
    var availableLocales = (_a = instance.availableLocales) !== null && _a !== void 0 ? _a : (0, exports.getAvailableLocalesByRegion)(instance.region);
    return availableLocales.includes(locale);
};
exports.localeIsSupported = localeIsSupported;
